'use client'
import React, {createContext, useContext} from 'react';
import {Breadcrumbs} from "@/libs/contentful/fetch/content/buildBreadcrumb";

const BreadcrumbsContext = createContext([{
    slug: '',
    title: '',
}]);

interface Props {
    children?: React.ReactNode
    breadcrumbs: Breadcrumbs[]
}

export function BreadcrumbProvider({ children, breadcrumbs }: Props) {
    return (
        <BreadcrumbsContext.Provider value={breadcrumbs}>
            {children}
        </BreadcrumbsContext.Provider>
    );
}

export function getBreadcrumbs():Breadcrumbs[] {
    return useContext(BreadcrumbsContext);
}